import { load } from '@/router/routes/index';

export default [
    {
        path: 'works',
        name: 'work.index',
        component: load('work/WorkIndex'),
        meta: { auth: true },
    },
    {
        path: 'works/create',
        name: 'work.create',
        component: load('work/WorkCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'works/:workId',
        component: load('work/WorkDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('work/WorkShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'work.show',
                        component: load('work/WorkShowOverview'),
                        meta: { auth: true },
                    },
                    {
                        path: 'tasks',
                        name: 'work.show.tasks',
                        component: load('work/WorkShowTasks'),
                        meta: { auth: true },
                    },
                    {
                        path: 'attachments',
                        name: 'work.show.attachments',
                        component: load('work/WorkShowAttachments'),
                        meta: { auth: true },
                    },
                ],
            },
            {
                path: 'edit',
                name: 'work.edit',
                component: load('work/WorkEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            },
        ],
    },
    {
        path: 'works/types/create',
        name: 'work.type.create',
        component: load('work/WorkTypeCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'tasks',
        name: 'task.index',
        component: load('task/TaskIndex'),
        meta: { auth: true },
    },
    {
        path: 'tasks/create',
        name: 'task.create',
        component: load('task/TaskCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'tasks/:taskId/edit',
        name: 'task.edit',
        component: load('task/TaskEdit'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'tasks/types/create',
        name: 'task.type.create',
        component: load('task/TaskTypeCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
];
